require('./template.js');
var validUrl = require('valid-url');

PegasusTemplate.WebTemplate = PegasusTemplate.Template.extend({
  fragments: [],
  globalSettings: DS.attr('string'),
  html: DS.attr('string'),
  openingHtmlPart: DS.attr('string'),
  userDefinedBackgroundImage: null,
  userDefinedBackgroundColor: null,
  paletteType: 'WebTemplatePalette',
  bodyImageType: 'WebTemplateBodyImage',
  supportsRowColorOpacity: true,
  previewContent: function(_,value){
    if( typeof( value ) !== 'undefined' ){
      return value;
    }
    return '';
  }.property(),
  rowClass: function(){
    return PegasusTemplate.WebTemplateRegionView;
  },
  gallerySizeKey: 'landscape',
  insideHtmlPart: DS.attr('string'),
  uid: DS.attr('string'),
  maxImageWidth: 1200,
  maxContentWidth: 1024, // this is kind of strange but we use this value to calculate other things
  contentRoot: function(){
    return PegasusTemplate.canvasInstance;
  },
  globalManipulationClass: function(){
    return PegasusTemplate.WebTemplateBlockRegionInstanceView;
  }.property(),
  backup: function(){
    return PegasusTemplate.blockRegionInstance.mutateForOut(null, true).editor_cookie;
  }
});

PegasusTemplate.WebTemplate.FIXTURES = [];

(function(){

  function resetBodyBackground(template){
    var doc = document.createElement('html');
    doc.innerHTML = template;
    $(doc).find('body').removeAttr('data-vr-default-background-image-override');
    return "<!DOCTYPE html>" + doc.outerHTML;
  }

  function extractHtmlChunks(template){
    var positionOfBodyClosing = template.search(/<\/body>/),
      positionOfBodyOpening = template.search(/<body/),
      positionInsideOfBody;

    if (positionOfBodyOpening === -1 || positionOfBodyClosing === -1) {
      throw new Error('Error processing message template, expected a body element.');
    }
    // move split postition to inside of body element
    positionInsideOfBody = template.slice(positionOfBodyOpening);
    positionInsideOfBody = positionInsideOfBody.search(/>/) + positionOfBodyOpening + 1;

    return {
      // preserve opening html, head and body (with any attributes, e.g. style) elements
      openingHtmlHeadBody: template.slice(0, positionInsideOfBody),
      // encapsulate what is changing... the body element's innerHTML
      insideBody: template.slice(positionInsideOfBody, positionOfBodyClosing),
      // preserve closing body and html elements
      closingBodyHTML: template.slice(positionOfBodyClosing)
    };
  }


  function extractDefaults(template){
    var doc = document.createElement('html'),
      result;

    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */

    var data = doc.getElementsByTagName('body')[0].dataset;

    var defaultBackgroundColor = data.vrDefaultBackgroundColor || '#C1C1C1',
      userSelectedPrimaryColor = data.vrThemePrimaryColorOverride,
      userSelectedSecondaryColor = data.vrThemeSecondaryColorOverride,
      defaultBackgroundImageCovers = data.vrDefaultBackgroundImageCovers,
      defaultBackgroundImage = data.vrDefaultBackgroundImageOverride || data.vrDefaultBackgroundImage || '',
      defaultFontFace = data.vrDefaultFontFace || '',
      defaultThemeColor = data.vrDefaultThemeColor || '#F1F1F1',
      defaultSuccessActionId = data.vrSuccessActionId || '1',
      templateThemeName = data.vrDefaultThemeName;

    var toolbarController = PegasusTemplate.lookupController('toolbar');

    if ( userSelectedPrimaryColor ) {
      toolbarController.set('selectedPrimaryColor', userSelectedPrimaryColor);
    }

    if ( userSelectedSecondaryColor ) {
      toolbarController.set('selectedSecondaryColor', userSelectedSecondaryColor);
    }

    var theme = {
      name: templateThemeName
    };

    function logoEnabled(){
      if ( PegasusTemplate.get('options.isWhiteLabeled') ) { return false; }
      // if they've downgraded or have never upgraded
      if ( !toolbarController.get('isAuthorizedToRemoveLogo') ) { return 'true'; }
      // if it hasn't yet been defined
      if ( typeof( data.vrFooterLogoEnabled ) === 'undefined' ) {
        return toolbarController.get('userLevelLogoHidden') ? '' : 'true';
      }
      // else if it's already been defined
      return data.vrFooterLogoEnabled;
    }

    result = {
      isFooterLogoEnabled: logoEnabled(),

      defaultBackgroundImage: defaultBackgroundImage,
      defaultBackgroundColor: defaultBackgroundColor,
      defaultFontFace: defaultFontFace,
      defaultThemeColor: defaultThemeColor,
      successActionId: defaultSuccessActionId,
      selectedBackgroundImageCovers: defaultBackgroundImageCovers,
      selectedBackgroundImage: defaultBackgroundImage,
      selectedBackgroundColor: data.vrDefaultBackgroundColorOverride || defaultBackgroundColor,
      selectedFontFace: data.vrDefaultFontFaceOverride || defaultFontFace,
      selectedRowColor: data.vrDefaultThemeColorOverride || defaultThemeColor,
      selectedTheme: theme,
      selectedIsAnimatedGif: data.vrIsBackgroundAnimatedGif || 'false',
      selectedBorderWidth: data.vrDefaultBorderThickness,
      selectedBorderRadius: data.vrDefaultBorderRadius,
      selectedBorderColor: data.vrDefaultBorderColor,
      selectedShadowSpreadRadius: data.vrDefaultShadowWidth,
      selectedShadowBlurRadius: data.vrDefaultShadowBlur
    };

    return result;
  }

  function extractGlobalSettings(template) {
    var doc = document.createElement('html');
    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */
    return doc.getElementsByTagName('body')[0].dataset.vrGlobalSettings || null;
  }

  function addBodyData(template){
    var doc = document.createElement('html'),
      controller = PegasusTemplate.lookupController('toolbar');

    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */
    $(doc).find('body').
      attr({
        'data-vr-footer-logo-enabled': controller.get('isFooterLogoEnabled') ? "true" : '',
        'data-vr-theme-primary-color-override': controller.get('selectedPrimaryColor'),
        'data-vr-theme-secondary-color-override': controller.get('selectedSecondaryColor'),
        'data-vr-default-background-image-covers': controller.get('selectedBackgroundImageCovers'),
        'data-vr-default-background-image-override': controller.get('selectedBackgroundImage'),
        'data-vr-default-background-color-override': controller.get('selectedBackgroundColor'),
        'data-vr-is-background-animated-gif': controller.get('selectedIsAnimatedGif'),
        'data-vr-success-action-id': controller.get('successActionId'),
        'data-vr-default-font-face-override': controller.get('selectedFontFace'),
        'data-vr-default-theme-color-override': controller.get('selectedRowColor'),
        'data-vr-default-theme-name': controller.get('selectedTheme.name'),
        'data-vr-default-shadow-width': controller.get('selectedShadowSpreadRadius'),
        'data-vr-default-shadow-blur': controller.get('selectedShadowBlurRadius'),
        'data-vr-default-border-radius': controller.get('selectedBorderRadius'),
        'data-vr-default-border-color': controller.get('selectedBorderColor'),
        'data-vr-default-border-thickness': controller.get('selectedBorderWidth')
      });

    return "<!DOCTYPE html>" + doc.outerHTML;
  }

  function addBodyStyles(template){
    var doc = document.createElement('html');
    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */
    $(doc).find('body').css( 'font-family', PegasusTemplate.lookupController('toolbar').get('selectedFontFace') );
    return "<!DOCTYPE html>" + doc.outerHTML;
  }

  function addSignupFormJS(template) {
    var sufJS = '<script src="' + PegasusTemplate.get('templateAssetHost') +'/pegasus_template/assets/form_js.js"></script>',
    template = template.replace('</body>', sufJS + '</body>');
    return template;
  }

  function addLandingPageIFrameJS(template) {
    var sufJS = '<script src="' + PegasusTemplate.get('templateAssetHost') +'/pegasus_template/assets/landing_page_widgets.js"></script>',
    template = template.replace('</body>', sufJS + '</body>');
    return template;
  }

  function generateQuery(block){
    return block.get('media_queries').reduce(function(accum, item){
      accum[item.inflection_point] = accum[item.inflection_point] || [];
      accum[item.inflection_point].push( {
        className: item.class_name,
        style: item.style,
        propertyName: item.property_name
      } );
      return accum;
    }, {});
  }

  function addMediaQueries(template){
    var doc = document.createElement('html');
    doc.innerHTML = template; /* using jquery's html() will drop the body tag, do not use */
    var head = $(doc).find('head');
    var styles = $('<style type="text/css">');
    styles.insertAfter(head.find('style').first());

    var rowNames = $(doc).find('body').find('.vr-row').map(function(i,x){ return $(x).attr('name'); });

    rowNames.toArray().uniq().forEach(function(name){
      var block = PegasusTemplate.lookupStore().all(PegasusTemplate.Block).filterProperty('name', name).get('firstObject');
      var queries = [];
      if ( block.get('media_queries') ){
        queries.push( generateQuery( block ) );
      }
      queries.forEach(function(q){
        var opening = '{',
          closing = '}',
          selector;

        Object.keys( q ).sort().reverse().forEach(function(inflection){
          var rules = q[inflection],
            queryRule = '',
            selectorParts,
            isQuotedClass,
            quoteEnd;

          rules.forEach(function(rule){
            isQuotedClass = rule.className.indexOf('"') === 0;

            if ( isQuotedClass ) {
              quoteEnd = rule.className.lastIndexOf('"') + 1;

              selectorParts = [
                rule.className.slice(0, quoteEnd),
                rule.className.slice(quoteEnd)
              ];
            } else {
              selectorParts = rule.className.split(' ');
            }

            selector = 'body[yahoo] [name="'+name+'"] [class='+ selectorParts[0] +'] ' + selectorParts.slice(1).join(' ');
            queryRule = queryRule + "@media only screen and (" + rule.propertyName +':'+ inflection +') {' + selector + ' {';
            queryRule = queryRule + rule.style + closing + closing;
          });

          styles.html( styles.html() + queryRule );
        });
      });
    });

    // NOTE the lack of the 'g' qualifier
    // we insertAfter the first style so we can safely assume the textual
    // representation of that heirarchy could be conjoined with the following.
    //
    // Why?  Zimbra treats all elements past the first style element (not includeing the one it
    // inserts) as text and breaks the preview snippet by inserting style definitions.
    return "<!DOCTYPE html>" + doc.outerHTML.replace(/<\/style><style type="text\/css">/,'');
  }

  PegasusTemplate.WebTemplate.reopen({
    assembleStructured: function(templateHTML){
      var base = templateHTML,
        globalSettings = extractGlobalSettings(base),
        defaults = extractDefaults(base),
        product = null,
        chunks,
        mutation = function(){
          return chunks.openingHtmlHeadBody.slice( chunks.openingHtmlHeadBody.search(/<body/) ) + /* don't include the head in the editor interface */
            '{{view PegasusTemplate.WebTemplateCanvasInstanceView}}' +
            '{{#unless PegasusTemplate.blockRegionInstance.length}}{{view PegasusTemplate.NoRowsView}}{{/unless}}' +
            '{{view PegasusTemplate.WebTemplateFooterShowView}}' +
            chunks.closingBodyHTML;
        }.bind(this);

      base = resetBodyBackground( base );
      chunks = extractHtmlChunks(base || "<html><head></head><body></body></html>"),

      Em.set(PegasusTemplate, 'defaults', defaults);

      // Clear the existing value as the app exists as a single render
      // entity.
      PegasusTemplate.lookupController('toolbar').set( 'selectedTheme', null );
      PegasusTemplate.lookupController('toolbar').setProperties(
        defaults
      );

      return this.store.createRecord(PegasusTemplate.WebTemplate, {
        html: mutation(),
        globalSettings: chunks.globalSettings || '',
        openingHtmlPart: chunks.openingHtmlHeadBody,
        insideHtmlPart: chunks.insideBody,
        closingHtmlPart: chunks.closingBodyHTML
      });
    },

    createFromExternal: function(){
      var assetHostInterpolatedTemplate = PegasusTemplate.get('options.template').
          replace(/{SERVER_URL}/g, PegasusTemplate.get('templateAssetHost')).
          replace("body[yahoo] > table[data-vr-structure-canvas]", "body[yahoo] [data-vr-structure-canvas]").
          replace("body[yahoo] td[data-vr-structure-cell]", "body[yahoo] [data-vr-structure-cell]"),
        data = {
            id: 1,
            editor_cookie: assetHostInterpolatedTemplate
          },
        message = assetHostInterpolatedTemplate,
        structured = this.assembleStructured( message );
        data = $.extend(data,
          PegasusTemplate.get('options.social_follow'));

      return {
        data: data,
        model: structured
      };
    },

    generateOutput: function(forSending) {
      var openingHtml = PegasusTemplate.loadedTemplate().get('openingHtmlPart'),
        closingHtml = PegasusTemplate.loadedTemplate().get('closingHtmlPart'),
        canvas = PegasusTemplate.canvasInstance.mutateForOut(true),
        messageContent = canvas.message,
        socialFollowData = $.extend( PegasusTemplate.lookupController('socialFollow').get('content'), {}),
        previewSnippet = '';

      // We'll refuse to pass back information that we, autonomously, know is invalid
      var base = addBodyStyles( openingHtml + previewSnippet + messageContent + closingHtml );
      var sendableMessage = '';

      var editorStateCookieVersionOfTheMessage = addBodyData( openingHtml + canvas.editor_cookie + closingHtml );
      var images = [];

      if ( forSending ) {
        sendableMessage = addMediaQueries( base );
        sendableMessage = addSignupFormJS( sendableMessage );
        sendableMessage = addLandingPageIFrameJS( sendableMessage );

        function generateParsable(message) {
          var doc = document.implementation.createHTMLDocument(""),
            doc_elt = doc.documentElement,
            first_elt;

          doc_elt.innerHTML = message;

          return $(doc_elt);
        }

        var elements = generateParsable(editorStateCookieVersionOfTheMessage).find('[data-src], [data-background-image], [data-vr-default-background-image-override], [data-vr-default-background-image]');
        elements = elements.add(generateParsable(sendableMessage).find('[data-src], [data-background-image], [data-vr-default-background-image-override], [data-vr-default-background-image]') );

        var data;
        var $x;
        var elementData;

        elements.each(function(i,x){
          $x = $(x);
          elementData = x.dataset;
          var src = elementData.vrDefaultBackgroundImageOverride || elementData.backgroundImage || elementData.src;
          if ( !src ) { return; }

          data = {
            file: src,
            name: $x.attr('data-name') || 'embedded',
            alt: $x.attr('data-alt') || ''
          };

          images.push( data );
        });
      }

      var forms = [];
      var toolbarController = PegasusTemplate.lookupController('toolbar');

      // if redirect is selected but there is no url, revert to Close
      if ( toolbarController.get('isRedirectSelected') ) {
        if ( !toolbarController.get('successActionRedirectURL') ) {
          toolbarController.set('successActionId', '1');
        }
      }

      if ( forSending ) {
        var defaultListId = toolbarController.get('defaultListId');
        if ( defaultListId ) {
          editorStateCookieVersionOfTheMessage = editorStateCookieVersionOfTheMessage.replace(/data-form-list-id=""/g, 'data-form-list-id="'+defaultListId+'"');
        }

        var elements =  generateParsable(editorStateCookieVersionOfTheMessage).find('[data-field-order]');

        var data;
        var $x;
        var elementData;

        elements.each(function(i,x){
          $x = $(x);
          elementData = x.dataset;
          var fields = elementData.fieldOrder;
          if ( !fields ) { return; }

          inputs = fields.split(',');

          inputs = inputs.map(function(input){
            var parts = input.split('-delimiter-');
            return {
              type: parts[0],
              name: parts[1],
              placeholder: parts[2]
            };
          });

          data = {
            list_id: elementData.formListId || defaultListId,
            form_name: elementData.formName,
            fields: inputs
          };

          forms.push( data );
        });

        toolbarController.set('defaultListId', null);
      }


      var redirectURL = '';
      if ( toolbarController.get('isRedirectSelected') ) {
        redirectURL = toolbarController.get('successActionRedirectURL');
        if ( ! validUrl.isUri( redirectURL ) ) {
          redirectURL = '';
        }
      }

      var result = {
        // message data
        message: sendableMessage,
        editor_cookie: editorStateCookieVersionOfTheMessage,

        images: images,
        forms: forms,
        update_forms: true,

        // social follow urls
        success_redirect_url: redirectURL,
        pinterest_url: socialFollowData.pinterest_url,
        facebook_url: socialFollowData.facebook_url,
        twitter_url: socialFollowData.twitter_url,
        google_url: socialFollowData.google_url,
        youtube_url: socialFollowData.youtube_url,
        linkedin_url: socialFollowData.linkedin_url,
        instagram_url: socialFollowData.instagram_url,
        snapchat_url: socialFollowData.snapchat_url,
        tumblr_url: socialFollowData.tumblr_url
      };

      if ( toolbarController.get('didToggleFooterLogo') ) {
        result.did_toggle_footer_logo = true;
        result.hide_implementor_logo = !toolbarController.get('isFooterLogoEnabled');
      }

      return result;
    }
  });
})();
